import { InstanceScreen } from 'component/navigation/instance';
import { useLocalSearchParams } from 'expo-router';

export default function SpaceIndexScreen() {
    const { commentID, vote } = useLocalSearchParams<'/[siloKey]/question/[instanceKey]'>();
    return <InstanceScreen params={{ commentID, vote }} />;
}
